import Button from "@/common/components/Button";
import { MissionTableRow } from "./missionsTransformer";
import { ArrowBigRight } from "lucide-react";
import { Link } from "react-router-dom";

type TableTransformerOptions = {
  canShowMission: boolean;
};

export class MissionsTableTransformer {
  static tableTransformer({ canShowMission }: TableTransformerOptions) {
    return (missionRows: MissionTableRow[]) => {
      return missionRows.map((missionRow) => {
        const showButton = (
          <Button
            variant="link-white"
            className="p-0"
            operationKlassToCheckPermission="Admin::Tmais::Missions::Show"
            noPermissionText="Você não tem permissão para acessar"
          >
            <ArrowBigRight />
          </Button>
        );

        return {
          id: missionRow.id,
          establishment: missionRow.establishment,
          status: (
            <span className="px-3 py-1 rounded-full text-sm font-semibold text-white">
              {missionRow.statusLabel}
            </span>
          ),
          name: missionRow.name,
          start_date: missionRow.start_date,
          end_date: missionRow.end_date,
          actions: canShowMission ? (
            <Link to={`/tmais-missions/${missionRow.id}`}>{showButton}</Link>
          ) : (
            showButton
          ),
        };
      });
    };
  }
}

